
            import { createSnippetComponent } from 'nostalgie/internal/components';

            export default createSnippetComponent({'bgColor':'#1E1E1E','fgColor':'#D4D4D4','firstLineOffset':0,'language':'typescript','tokensByLine':[[['export','#C586C0'],' ',['function','#569CD6'],' ',['getResourceUsage','#DCDCAA'],'() {'],['  ',['return','#C586C0'],' ',['process','#9CDCFE'],'.',['resourceUsage','#DCDCAA'],'();'],['}']]});
          